import { useLocation, useNavigate } from "react-router-dom";
import { ChatWidget } from "@medipha/chat";
import "@medipha/chat/styles.css";
import "./override.css";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import useChatRuntimeProps from "./useChatRuntimeProps";

const CHAT_ERP_PATH = `${APP_PREFIX_PATH}/chat-erp`;


const CLOSE_ANIMATION_NAME = "erp-chat-rail-collapse";

const ChatRail = ({ isOpen, isClosing, onRequestClose, onCloseEnd }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { userId: chatUserId, ...chatRuntimeProps } = useChatRuntimeProps();

  // Dang o trang/modal chat full -> khong hien rail nua cho khoi chong hai giao dien chat.
  const isFullPage = location.pathname.startsWith(CHAT_ERP_PATH);

  if (!chatUserId || isFullPage) return null;

  const handleOpenFullPage = (conversationId) => {
    const path = conversationId
      ? `${CHAT_ERP_PATH}/${conversationId}`
      : CHAT_ERP_PATH;

    // Giu trang ERP hien tai lam nen -> routes/index.js render ChatModal de len (giong nut noi cu).
    navigate(path, { state: { backgroundLocation: location } });
  };

  return (
    <aside
      className={`erp-chat-rail${isClosing ? " erp-chat-rail--closing" : ""}`}
      hidden={!isOpen}
      // animationend cua cac phan tu con cung noi len day -> chi nhan dung hieu ung thu rail.
      onAnimationEnd={(e) => {
        if (e.animationName === CLOSE_ANIMATION_NAME) onCloseEnd();
      }}
    >
      <ChatWidget
        key={chatUserId}
        userId={chatUserId}
        {...chatRuntimeProps}
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        onOpenFullPage={handleOpenFullPage}
      />
    </aside>
  );
};

export default ChatRail;
